export * from './DetailsPage'
